import { Array, Boolean, Number, Optional, Record, Static, String, Union, Unknown } from 'runtypes';

export const ResultRunTypeBaseRecordRunType = Record({
	csrfToken: String,
	isAlreadyPaginatedAndSorted: Optional(Boolean),
	keys: Array(String),
	processIds: Array(String),
	results: Union(Array(Unknown), Unknown),
	totalCount: Number.Or(String),
});

export type ResultRunTypeBaseRecord = Static<typeof ResultRunTypeBaseRecordRunType>;
